export default {"src":"/_next/static/media/design.ae0be839.svg","height":78,"width":132};